export default __webpack_public_path__ + "static/node-icon-420a66a0624537bb0fa1b51c87c07961.svg";